import angular from 'angular';
import '../../layouts.module';
import template from './sidebar.component.html';
import './sidebar.component.scss';
import logoUrl from '../../../assets/images/whatsapp.png';
import { COMPANY_BRANDING_CHANGED_EVENT } from '../../../core/services/company-branding.service';
import { GUIDE_OPEN_EVENT } from '../automation-guide/automation-guide.component';

class SidebarController {
  constructor(
    MenuService,
    StorageService,
    STORAGE_KEYS,
    $state,
    CompanyBrandingService,
    UploadService,
    EventBusService,
    $element,
    $timeout,
    $animate
  ) {
    this.MenuService = MenuService;
    this.StorageService = StorageService;
    this.STORAGE_KEYS = STORAGE_KEYS;
    this.$state = $state;
    this.CompanyBrandingService = CompanyBrandingService;
    this.UploadService = UploadService;
    this.EventBusService = EventBusService;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$animate = $animate;
    this.logoUrl = logoUrl;
    this.logoAlt = 'ZAP CashPago';
  }

  $onInit() {
    this.sections = this.MenuService.getMenu();
    this.collapsed = Boolean(this.StorageService.get(this.STORAGE_KEYS.SIDEBAR_COLLAPSED));
    this.brandingSubscription = this.EventBusService.on(COMPANY_BRANDING_CHANGED_EVENT).subscribe(
      (branding) => this.applyBranding(branding)
    );
    this.CompanyBrandingService.get().then(
      (branding) => this.applyBranding(branding),
      () => null
    );
  }

  $postLink() {
    this.$animate.enabled(this.$element, false);
  }

  $onChanges(changes) {
    if (changes.open && changes.open.currentValue) {
      this.$timeout(() => {
        const firstItem = this.$element[0].querySelector('.cp-sidebar__item[href]');
        if (firstItem) firstItem.focus();
      });
    }
  }

  $onDestroy() {
    if (this.brandingSubscription) this.brandingSubscription.unsubscribe();
  }

  applyBranding(branding) {
    const fileId = branding.logoFileId;
    this.brandingFileId = fileId;
    this.logoAlt = branding.nome || 'ZAP CashPago';
    if (!fileId) {
      this.logoUrl = logoUrl;
      return;
    }
    this.UploadService.cachedFileUrl(fileId).then(
      (url) => {
        if (this.brandingFileId === fileId) this.logoUrl = url;
      },
      () => {
        if (this.brandingFileId === fileId) this.logoUrl = logoUrl;
      }
    );
  }

  toggleCollapsed() {
    this.collapsed = !this.collapsed;
    this.StorageService.set(this.STORAGE_KEYS.SIDEBAR_COLLAPSED, this.collapsed);
  }

  openGuide(guideId) {
    this.EventBusService.emit(GUIDE_OPEN_EVENT, guideId);
  }

  isActive(state) {
    return this.$state.includes(state);
  }

  isAvailable(state) {
    return Boolean(this.$state.get(state));
  }
}

SidebarController.$inject = [
  'MenuService',
  'StorageService',
  'STORAGE_KEYS',
  '$state',
  'CompanyBrandingService',
  'UploadService',
  'EventBusService',
  '$element',
  '$timeout',
  '$animate'
];

angular.module('app.layouts').component('cpSidebar', {
  controller: SidebarController,
  controllerAs: 'vm',
  bindings: {
    open: '<',
    onClose: '&'
  },
  template
});
